/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Option-level seat timing and assignment evidence. A saved selection remains an unconfirmed draft.
 * @export
 * @interface FlightSeatCapabilities
 */
export interface FlightSeatCapabilities {
  /**
   *
   * @type {string}
   * @memberof FlightSeatCapabilities
   */
  selectionStage: FlightSeatCapabilitiesSelectionStageEnum;
  /**
   *
   * @type {string}
   * @memberof FlightSeatCapabilities
   */
  paymentTiming: FlightSeatCapabilitiesPaymentTimingEnum;
  /**
   *
   * @type {string}
   * @memberof FlightSeatCapabilities
   */
  assignmentStatus: FlightSeatCapabilitiesAssignmentStatusEnum;
  /**
   *
   * @type {string}
   * @memberof FlightSeatCapabilities
   */
  unsupportedReason?: string;
}

/**
 * @export
 */
export const FlightSeatCapabilitiesSelectionStageEnum = {
  Booking: "booking",
  Postbooking: "postbooking",
  Unsupported: "unsupported",
} as const;
export type FlightSeatCapabilitiesSelectionStageEnum =
  (typeof FlightSeatCapabilitiesSelectionStageEnum)[keyof typeof FlightSeatCapabilitiesSelectionStageEnum];

/**
 * @export
 */
export const FlightSeatCapabilitiesPaymentTimingEnum = {
  None: "none",
  Booking: "booking",
  Postbooking: "postbooking",
  Unsupported: "unsupported",
} as const;
export type FlightSeatCapabilitiesPaymentTimingEnum =
  (typeof FlightSeatCapabilitiesPaymentTimingEnum)[keyof typeof FlightSeatCapabilitiesPaymentTimingEnum];

/**
 * @export
 */
export const FlightSeatCapabilitiesAssignmentStatusEnum = {
  Unconfirmed: "unconfirmed",
  Confirmed: "confirmed",
} as const;
export type FlightSeatCapabilitiesAssignmentStatusEnum =
  (typeof FlightSeatCapabilitiesAssignmentStatusEnum)[keyof typeof FlightSeatCapabilitiesAssignmentStatusEnum];

/**
 * Check if a given object implements the FlightSeatCapabilities interface.
 */
export function instanceOfFlightSeatCapabilities(
  value: object
): value is FlightSeatCapabilities {
  if (!("selectionStage" in value) || value["selectionStage"] === undefined)
    return false;
  if (!("paymentTiming" in value) || value["paymentTiming"] === undefined)
    return false;
  if (!("assignmentStatus" in value) || value["assignmentStatus"] === undefined)
    return false;
  return true;
}

export function FlightSeatCapabilitiesFromJSON(
  json: any
): FlightSeatCapabilities {
  return FlightSeatCapabilitiesFromJSONTyped(json, false);
}

export function FlightSeatCapabilitiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSeatCapabilities {
  if (json == null) {
    return json;
  }
  return {
    selectionStage: json["selection_stage"],
    paymentTiming: json["payment_timing"],
    assignmentStatus: json["assignment_status"],
    unsupportedReason:
      json["unsupported_reason"] == null
        ? undefined
        : json["unsupported_reason"],
  };
}

export function FlightSeatCapabilitiesToJSON(
  json: any
): FlightSeatCapabilities {
  return FlightSeatCapabilitiesToJSONTyped(json, false);
}

export function FlightSeatCapabilitiesToJSONTyped(
  value?: FlightSeatCapabilities | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    selection_stage: value["selectionStage"],
    payment_timing: value["paymentTiming"],
    assignment_status: value["assignmentStatus"],
    unsupported_reason: value["unsupportedReason"],
  };
}
